module.exports = __webpack_public_path__ + "static/media/sonyproduct2banner.0247242c.jpg";